import { AccessTime, ArrowUpward, CancelOutlined, Loop, Person, ShoppingBagOutlined, ShoppingCartOutlined, TaskAlt } from '@mui/icons-material'
import { Box, Chip, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { orderStatusColors } from '../../Component/OrderStatusColors/orderStatusColors'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { RootState } from '../../Redux/store'
import { useSelector } from 'react-redux'
import dayjs, { Dayjs } from 'dayjs'
import AreaChart from '../../Component/Charts/AreaChart'
import DonutChart from '../../Component/Charts/DonuteChart'
import { ApiGetDealerDashboard } from '../../Core/Apicall'
import { toast } from 'react-toastify'
import { DealerDashboardInterface, ImportantUpdate } from '../../types/DealerDashboard'
import { AiOutlineProduct } from 'react-icons/ai'
import { paymentStatusColor } from '../../Component/PaymentStatusColor/paymnetStatusColor'

function DealerDashboard() {
    const { userDetails } = useSelector((state: RootState) => state.global)
    const [selectedDate, setSelectedDate] = useState<Dayjs | null>(dayjs());
    const [dealerDashboard, setDealerDashboard] = useState<DealerDashboardInterface>()


    const getDashboard = async () => {
        try {
            const data = `?month=${(selectedDate?.month() || 0) + 1}&year=${selectedDate?.year()}`
            const res = await ApiGetDealerDashboard(data)
            if (res?.status) {
                setDealerDashboard(res?.data)
            }
        } catch (error: any) {
            toast.error(error?.message || "Somenthing went Worong")
        }
    }

    useEffect(() => {
        selectedDate && getDashboard()
    }, [selectedDate])



    const getActivityIcon = (type: string) => {
        switch (type) {
            case "CLIENT_CREATED":
            case "CLIENT_UPDATED":
            case "CLIENT_DELETED":
            case "SUB_CLIENT_CREATED":
            case "SUB_CLIENT_UPDATED":
            case "SUB_CLIENT_DELETED":
                return <Person className="text-main" />;

            case "PRODUCT_CREATED":
                return AiOutlineProduct({
                    size: 24,
                    color: "var(--primary-color)",
                });

            case "ORDER_CREATED":
            case "ORDER_STATUS_CHANGED":
            case "ORDER_APPROVED":
            case "ORDER_REJECTED":
            case "ORDER_UPDATED":
            case "PAYMENT_RECEIVED":
            case "INVOICE_CREATED":
                return <ShoppingCartOutlined className="text-main" />;

            default:
                return <Person className="text-main" />;
        }
    };

    return (
        <Box className='p-lg-3 p-xl-4 p-2'>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box className="d-flex justify-content-md-end justify-content-between gap-2">
                    <Box className='d-inline-block d-md-none'>
                        <Typography variant='h6' className='fw-bold' sx={{ lineHeight: 'normal' }}>Welcome Back, {userDetails?.firstName}</Typography>
                        <Typography sx={{ fontSize: '12px' }}>Here's what's happening with your platform today</Typography>
                    </Box>
                    {/* <Button className='btn-main py-1 px-3'>Conect to Razorpay</Button> */}
                    <DatePicker
                        value={selectedDate}
                        onChange={(newValue) => setSelectedDate(newValue)}
                        format='MMM-YY'
                        views={['month', 'year']}
                        slotProps={{
                            textField: {
                                size: "small",
                                sx: { width: 150 }
                            },
                        }}
                    />
                </Box>
            </LocalizationProvider>
            <Grid container spacing={1} className='my-2 mb-3'>
                <Grid size={{ xs: 6, md: 4, lg: "grow" }} className='border-main card-bg  border-10 p-3'>
                    <Grid container>
                        <Grid size='grow'>
                            <Typography variant='body2'>Total Orders</Typography>
                            <Typography variant='h5'>{dealerDashboard?.orderSummary?.totalOrders}</Typography>
                            {/* <Typography variant='caption'> {(0) >= 0 ? <ArrowUpward className='text-main' sx={{ fontSize: '16px' }} /> : <ArrowDownward className='text-danger' sx={{ fontSize: '16px' }} />}<span className={(12) >= 0 ? 'text-main' : 'text-danger'}>12.15%</span>  from last month</Typography> */}
                        </Grid>
                        <Grid size='auto'>
                            <Box className='p-2 bg-second-light border-10'>
                                <ShoppingBagOutlined className='text-main' sx={{ fontSize: '32px' }} />
                                {/* {BsPersonWorkspace({ size: 32, color: 'var(--primary-color)' })} */}
                            </Box>
                        </Grid>
                        {/* <Grid size={{xs:12}}>
              <Typography variant='caption'> {(0) >= 0 ? <ArrowUpward className='text-main' sx={{ fontSize: '16px' }} /> : <ArrowDownward className='text-danger' sx={{ fontSize: '16px' }} />}<span className={(12) >= 0 ? 'text-main' : 'text-danger'}>12.15%</span>  from last month</Typography>
            </Grid> */}
                    </Grid>
                </Grid>
                <Grid size={{ xs: 6, md: 4, lg: "grow" }} className='border-main card-bg  border-10 p-3'>
                    <Grid container>
                        <Grid size='grow'>
                            <Typography variant='body2'>Pending Orders</Typography>
                            <Typography variant='h5'>{dealerDashboard?.orderSummary?.pendingOrders}</Typography>
                            {/* <Typography variant='caption'> {(8.3) >= 0 ? <ArrowUpward className='text-main' sx={{ fontSize: '16px' }} /> : <ArrowDownward className='text-danger' sx={{ fontSize: '16px' }} />}<span className={(8.3) >= 0 ? 'text-main' : 'text-danger'}>{8.3}%</span>  from last month</Typography> */}
                        </Grid>
                        <Grid size='auto'>
                            <Box className='p-2 border-10' sx={{ bgcolor: `${orderStatusColors['PENDING'].bg} !important` }}>
                                <AccessTime sx={{ fontSize: '32px', color: `${orderStatusColors['PENDING'].color} !important`, }} />
                                {/* {AiOutlineProduct({ size: 32, color: 'var(--primary-color)' })} */}
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={{ xs: 6, md: 4, lg: "grow" }} className='border-main card-bg  border-10 p-3'>
                    <Grid container>
                        <Grid size='grow'>
                            <Typography variant='body2'>Processing Orders</Typography>
                            <Typography variant='h5'>{dealerDashboard?.orderSummary?.processingOrders}</Typography>
                            {/* <Typography variant='caption'> {(456) >= 0 ? <ArrowUpward className='text-main' sx={{ fontSize: '16px' }} /> : <ArrowDownward className='text-danger' sx={{ fontSize: '16px' }} />}<span className={(456) >= 0 ? 'text-main' : 'text-danger'}>{456}%</span>  from last month</Typography> */}
                        </Grid>
                        <Grid size='auto'>
                            <Box className='p-2 border-10' sx={{ bgcolor: `${orderStatusColors['PROCESSING'].bg} !important` }}>
                                <Loop sx={{ fontSize: '32px', color: `${orderStatusColors['PROCESSING'].color} !important`, }} />
                                {/* {AiOutlineProduct({ size: 32, color: 'var(--primary-color)' })} */}
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={{ xs: 6, md: 4, lg: "grow" }} className='border-main card-bg  border-10 p-3'>
                    <Grid container>
                        <Grid size='grow'>
                            <Typography variant='body2'>Completed Orders</Typography>
                            <Typography variant='h5'>{dealerDashboard?.orderSummary?.completedOrders}</Typography>
                            {/* <Typography variant='caption'> {(10.1) >= 0 ? <ArrowUpward className='text-main' sx={{ fontSize: '16px' }} /> : <ArrowDownward className='text-danger' sx={{ fontSize: '16px' }} />}<span className={(10.1) >= 0 ? 'text-main' : 'text-danger'}>{10.1}%</span>  from last month</Typography> */}
                        </Grid>
                        <Grid size='auto'>
                            <Box className='p-2 border-10' sx={{ bgcolor: `${orderStatusColors['COMPLETED'].bg} !important` }}>
                                <TaskAlt sx={{ fontSize: '32px', color: `${orderStatusColors['COMPLETED'].color} !important` }} />
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={{ xs: 6, md: 4, lg: "grow" }} className='border-main card-bg  border-10 p-3'>
                    <Grid container>
                        <Grid size='grow'>
                            <Typography variant='body2'>Cancelled Orders</Typography>
                            <Typography variant='h5'>{dealerDashboard?.orderSummary?.cancelledOrders}</Typography>
                            {/* <Typography variant='caption'> {(10.1) >= 0 ? <ArrowUpward className='text-main' sx={{ fontSize: '16px' }} /> : <ArrowDownward className='text-danger' sx={{ fontSize: '16px' }} />}<span className={(10.1) >= 0 ? 'text-main' : 'text-danger'}>{10.1}%</span>  from last month</Typography> */}
                        </Grid>
                        <Grid size='auto'>
                            <Box className='p-2 border-10' sx={{ bgcolor: `${orderStatusColors['REJECTED'].bg} !important` }}>
                                <CancelOutlined className='text-red' sx={{ fontSize: '32px', color: `${orderStatusColors['REJECTED'].color} !important` }} />
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container spacing={1} className="my-2 mb-3">
                <Grid
                    size={{ xs: 12, lg: 12, xl: 4 }}
                    className="border-main p-3 card-bg border-10"
                >
                    <Box className="d-flex mb-1 align-items-center justify-content-between">
                        <Typography variant="h6" className="fw-bold">
                            Revenue Overview
                        </Typography>
                    </Box>

                    <Typography variant="h4" className="text-main fw-bold">
                        {Number(dealerDashboard?.revenueDetails?.thisMonth).toLocaleString("en-US", {
                            style: "currency",
                            currency: "INR",
                        })}
                    </Typography>

                    <Typography variant="caption">
                        <ArrowUpward
                            className="text-main"
                            sx={{ fontSize: "16px" }}
                        />

                        <span className="text-main">
                            {dealerDashboard?.revenueDetails?.percentage}%
                        </span>{" "}
                        from last month
                    </Typography>

                    <Box className="w-100 mt-2">
                        <AreaChart
                            // revenueOverview={[
                            //     { week: "Week 1", revenue: 185000 },
                            //     { week: "Week 2", revenue: 195000 },
                            //     { week: "Week 3", revenue: 260000 },
                            //     { week: "Week 4", revenue: 320252 },
                            // ]}
                            revenueOverview={dealerDashboard?.revenueOverview ?? []}
                        />
                    </Box>
                </Grid>
                <Grid
                    size={{ xs: 12, lg: 12, xl: 4 }}
                    className="border-main p-3 card-bg  border-10 d-flex align-items-start flex-column"
                >
                    <Typography variant="h6" className="fw-bold">
                        Orders Status
                    </Typography>
                    <Box className='d-flex align-items-center w-100 justify-content-center' sx={{ flex: 1 }}>
                        <DonutChart data={dealerDashboard?.orderStatusOverview ?? []} />
                    </Box>
                </Grid>
                <Grid
                    size={{ xs: 12, lg: 12, xl: 4 }}
                    className="border-main p-3 card-bg border-10 d-flex align-items-start flex-column"
                >
                    <Typography variant="h6" className="fw-bold">
                        Important Updates
                    </Typography>
                    <Box className='mt-3'>
                        {dealerDashboard?.activityFeed?.slice(0, 6)?.map((activity: ImportantUpdate, index) => (
                            <Box
                                key={activity.activityLogId}
                                className={`d-flex align-items-center gap-3 justify-content-between w-100 pb-2 mb-2 ${index !== dealerDashboard.activityFeed.length - 1
                                    ? "border-bottom-main"
                                    : ""
                                    }`}
                            >
                                <Box
                                    className="d-flex align-items-center gap-2"
                                    sx={{ flex: 1 }}
                                >
                                    <Box className="p-1 border-50 bg-second-light">
                                        {getActivityIcon(activity.type)}
                                    </Box>
                                    <Tooltip title={activity.title}>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                display: "-webkit-box",
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: "vertical",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                            }}
                                        >
                                            {activity.title}
                                        </Typography>
                                    </Tooltip>
                                </Box>

                                <Typography
                                    variant="caption"
                                    sx={{ whiteSpace: "nowrap" }}
                                >
                                    {dayjs(activity.created_at).fromNow()}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                </Grid>
                <Grid
                    size={{ xs: 12, lg: 12, xl: 6 }}
                    className="border-main p-3 card-bg border-10 d-flex align-items-start flex-column"
                >
                    <Typography variant="h6" className="fw-bold">
                        Recent Orders
                    </Typography>
                    <TableContainer
                        className='mt-2'
                        sx={{
                            border: "1px solid #E5E7EB",
                            borderRadius: "10px",
                            width: '100%'
                            // overflow: "hidden",
                        }}
                    >
                        <Table sx={{ tableLayout: "fixed" }}>
                            <TableHead>
                                <TableRow
                                    sx={{
                                        bgcolor: "var(--primary-light-color)",

                                        "& th": {
                                            fontWeight: 600,
                                            color: "#555",
                                            py: 2,
                                            borderBottom: "1px solid #E5E7EB",
                                        },
                                    }}
                                >
                                    <TableCell>
                                        <Typography variant="caption">Order Number</Typography>
                                    </TableCell>

                                    <TableCell className='text-center'>
                                        <Typography variant="caption">Items</Typography>
                                    </TableCell>

                                    <TableCell className='text-center'>
                                        <Typography variant="caption">Order Date</Typography>
                                    </TableCell>
                                    <TableCell className='text-center'>
                                        <Typography variant="caption">Amount</Typography>
                                    </TableCell>

                                    <TableCell className='text-center'>
                                        <Typography variant="caption">Payment Status</Typography>
                                    </TableCell>

                                    <TableCell className='text-center'>
                                        <Typography variant="caption" className='text-center'>Order Status</Typography>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {dealerDashboard?.recentOrders?.map((item) => (
                                    <TableRow>
                                        <TableCell>
                                            <Typography variant="body2">{item?.orderNumber}</Typography>
                                        </TableCell>

                                        <TableCell className='text-center'>
                                            <Typography variant="body2">{item?.items?.length}</Typography>
                                        </TableCell>

                                        <TableCell className='text-center'>
                                            <Typography variant="body2">{dayjs(item?.created_at).format("DD MMM YYYY")}</Typography>
                                            <Typography variant="body2">{dayjs(item?.created_at).format("HH:mm a")}</Typography>
                                        </TableCell>
                                        <TableCell className='text-center'>
                                            <Typography variant="body2">
                                                {Number(item?.totalAmount)?.toLocaleString("en-US", {
                                                    style: "currency",
                                                    currency: "INR",
                                                })}
                                            </Typography>
                                        </TableCell>

                                        <TableCell className='text-center'>
                                            <Chip
                                                label={item?.payment_status}
                                                size="small"
                                                sx={{
                                                    backgroundColor: paymentStatusColor[item?.payment_status?.toUpperCase()].bg,
                                                    color: paymentStatusColor[item?.payment_status?.toUpperCase()].color,
                                                    fontWeight: 600,
                                                    borderRadius: "20px",
                                                    minWidth: 95,
                                                }}
                                            />
                                        </TableCell>

                                        <TableCell className='text-center'>
                                            <Chip
                                                label={item?.status}
                                                size="small"
                                                sx={{
                                                    backgroundColor: orderStatusColors[item?.status?.toUpperCase()].bg,
                                                    color: orderStatusColors[item?.status?.toUpperCase()].color,
                                                    fontWeight: 600,
                                                    borderRadius: "20px",
                                                    minWidth: 95,
                                                }}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
                <Grid
                    size={{ xs: 12, lg: 12, xl: 6 }}
                    className="border-main p-3 card-bg border-10 d-flex align-items-start flex-column"
                >
                    <Typography variant="h6" className="fw-bold">
                        Top Purchase
                    </Typography>
                    <TableContainer
                        className='mt-2'
                        sx={{
                            border: "1px solid #E5E7EB",
                            borderRadius: "10px",
                            width: '100%'
                            // overflow: "hidden",
                        }}
                    >
                        <Table sx={{ tableLayout: "fixed" }}>
                            <TableHead>
                                <TableRow
                                    sx={{
                                        bgcolor: "var(--primary-light-color)",

                                        "& th": {
                                            fontWeight: 600,
                                            color: "#555",
                                            py: 2,
                                            borderBottom: "1px solid #E5E7EB",
                                        },
                                    }}
                                >
                                    <TableCell>
                                        <Typography variant="caption">Product Name</Typography>
                                    </TableCell>

                                    <TableCell className='text-center'>
                                        <Typography variant="caption">Quantity</Typography>
                                    </TableCell>

                                    <TableCell className='text-center'>
                                        <Typography variant="caption">Amount</Typography>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {dealerDashboard?.topProducts?.map((item) => (
                                    <TableRow>
                                        <TableCell>
                                            <Typography variant="body2">{item?.productName}</Typography>
                                        </TableCell>

                                        <TableCell className='text-center'>
                                            <Typography variant="body2">{item?.totalQuantity}</Typography>
                                        </TableCell>

                                        <TableCell className='text-center'>
                                            <Typography variant="body2">
                                                {Number(item?.totalSpent)?.toLocaleString("en-US", {
                                                    style: "currency",
                                                    currency: "INR",
                                                })}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </Box>
    )
}

export default DealerDashboard
